import PhotoUpload from '@Components/ComposedComponents/PhotoUpload';


import { checkThumbnailsNames } from '@/utils/names';
import StepButtons from '../ComposedComponents/StepButtons';

const thumbnailTooltip = `The filename must use the following convention for thumbnails files: {referenceID}_{language-code}_thumbnail.jpg`;

export default function PhotoForm (props) {
	return (
		<>
			<PhotoUpload
				title="Thumbnail podcast upload"
				tooltip={thumbnailTooltip}
				checkNames={checkThumbnailsNames}
				{...props}
			/>
			<br/><br/>
			<StepButtons
				totalSteps={1}
				currentStep={0}
				setStep={() => {}}
				{...props}
			/>
		</>
	);
}